if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.sectionId;
      this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.button = this.querySelector('[data-sticky-button]');
      this.label = this.querySelector('[data-sticky-button-label]');
      this.priceElement = this.querySelector('[data-sticky-price]');
      if (!this.mainButton || !this.button) return;

      this.button.addEventListener('click', () => {
        if (this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true') return;
        this.mainButton.click();
      });

      this.sync();
      this.observeMainState();
      this.observeVisibility();
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    readPrice() {
      const container = document.getElementById(`price-${this.sectionId}`);
      if (!container || container.classList.contains('hidden')) return '';
      const onSale = container.querySelector('.price')?.classList.contains('price--on-sale');
      const element = onSale
        ? container.querySelector('.price-item--sale')
        : container.querySelector('.price__regular .price-item--regular');
      return element ? element.textContent.trim() : '';
    }

    sync() {
      const disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      const mainLabel = this.mainButton.querySelector('span')?.textContent.trim();

      if (mainLabel) this.label.textContent = mainLabel;
      this.priceElement.textContent = this.readPrice();
      this.button.disabled = this.mainButton.disabled;
      this.button.setAttribute('aria-disabled', String(disabled));
      this.button.classList.toggle('is-loading', this.mainButton.classList.contains('loading'));
    }

    observeMainState() {
      this.mutationObserver = new MutationObserver(() => this.sync());

      this.mutationObserver.observe(this.mainButton, {
        attributes: true,
        attributeFilter: ['disabled', 'aria-disabled', 'class'],
        childList: true,
        subtree: true,
        characterData: true,
      });

      const priceContainer = document.getElementById(`price-${this.sectionId}`);
      if (priceContainer) {
        this.mutationObserver.observe(priceContainer, {
          attributes: true,
          attributeFilter: ['class'],
          childList: true,
          subtree: true,
          characterData: true,
        });
      }
    }

    observeVisibility() {
      this.updateVisibility = () => {
        this.scrollTicking = false;
        const rect = this.mainButton.getBoundingClientRect();
        this.classList.toggle('is-visible', rect.height > 0 && rect.bottom < 60);
      };
      this.onScroll = () => {
        if (this.scrollTicking) return;
        this.scrollTicking = true;
        requestAnimationFrame(this.updateVisibility);
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.updateVisibility();
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart);
}
